import React from 'react';
import ProductCardSkeleton from './ProductCardSkeleton';

const DealCardSkeleton = () => {
    return <ProductCardSkeleton />;
};

export default DealCardSkeleton;
